module.exports = __webpack_public_path__ + "static/media/HCMM980.231c4f23.jpg";